import { PesquisaRelatorio } from '@app/models/pesquisa-relatorio';
import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';

import { CDSMask } from '@app/utils/cds-mask';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { MovimentacaoLancamento, LancamentoPesquisa } from '@app/pages/financeiro/lancamento/lancamento.model';

import { Filtros } from './filtros';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-rel-financeiro-extrato-bancario',
  templateUrl: './extrato-bancario.component.html',
  styleUrls: ['./extrato-bancario.component.scss']
})
export class RelatorioExtratoBancarioComponent implements OnInit {

  lstMovimentacaoLancamento: MovimentacaoLancamento[] = [];
  cdsMask: CDSMask = new CDSMask();
  filtros: Filtros = new Filtros();
  saldoTotal: number;
  lstUnidades: IdDescricao[];
  lstConta: IdDescricao[] = [];
  lstTipoDR: IdDescricao[] = [];
  lstTipoAcao: IdDescricao[] = [];
  lstGrupoPai: IdDescricao[] = [];
  lstNivel1: IdDescricao[] = [];
  lstNivel2: IdDescricao[] = [];
  lstNivel3: IdDescricao[] = [];
  lstNivel4: IdDescricao[] = [];

  listaNivel: { listaIdDescricao: IdDescricao[]; pesquisa: LancamentoPesquisa }[] = [];

  pesquisa: LancamentoPesquisa = new LancamentoPesquisa();
  pesquisaPai: LancamentoPesquisa = new LancamentoPesquisa();
  pesquisaNivel1: LancamentoPesquisa = new LancamentoPesquisa();
  pesquisaNivel2: LancamentoPesquisa = new LancamentoPesquisa();
  pesquisaNivel3: LancamentoPesquisa = new LancamentoPesquisa();
  pesquisaNivel4: LancamentoPesquisa = new LancamentoPesquisa();

  nivelPai = false;
  nivel1 = false;
  nivel2 = false;
  nivel3 = false;
  nivel4 = false;

  pesquisando = false;
  showTable = false;
  tipoPesquisa: string = 'simples';

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
    private utilitarioService: UtilitarioService
  ) { this.filtros.TipoDRId = 0; }

  ngOnInit() {
    this.pesquisa.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
    this.pesquisa.DataFinal = UtilitarioService.retornaDataAtualMaisDias(0);
    this.pesquisa.ContaId = 0;
    this.consultasService.consultar('DR').toPromise().then(data => this.lstTipoDR = data);
    this.consultasService.consultar('DR_PAI').toPromise().then(data => this.lstGrupoPai = data);
    this.consultasService.consultar('CONTA').toPromise().then(data => this.lstConta = data);
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
    this.consultasService.consultar('TIPODEACAO').toPromise().then(data => this.lstTipoAcao = data);
  }

  obterTodos() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    if (this.tipoPesquisa === 'detalhada')
      this.declaraNiveis();

    this.relatorioService.extratoBancario(this.pesquisa, this.tipoPesquisa)
      .toPromise().then(data => {
        this.lstMovimentacaoLancamento = data;
        if (this.lstMovimentacaoLancamento.length > 0) {
          this.saldoTotal = this.lstMovimentacaoLancamento[this.lstMovimentacaoLancamento.length - 1].Saldo;
        } else {
          this.saldoTotal = 0;
        }
        this.pesquisando = false;
        if (this.lstMovimentacaoLancamento.length === 0) {
          this.showTable = false;
          this.toastr.info('Busca não encontrou resultados');
        } else {
          this.showTable = true;
        }
      },
        () => {
          this.pesquisando = false
          this.toastr.warning("Realize a pesquisa novamente.")
        });
    //  () => this.pesquisando = false);
  }

  pesquisaNiveis() {

    this.consultasService.consultar('DR_NIVEIS', this.pesquisaPai.TipoDR).toPromise().then(data => this.lstNivel1 = data);
    this.consultasService.consultar('DR_NIVEIS', this.pesquisaNivel1.TipoDR).toPromise().then(data => this.lstNivel2 = data);
    this.consultasService.consultar('DR_NIVEIS', this.pesquisaNivel2.TipoDR).toPromise().then(data => this.lstNivel3 = data);
    this.consultasService.consultar('DR_NIVEIS', this.pesquisaNivel3.TipoDR).toPromise().then(data => this.lstNivel4 = data);
  }

  pesquisaProximoNivel(idTipoDR: string) {
    this.consultasService.consultar('DR_NIVEIS', idTipoDR).toPromise().then((data: IdDescricao[]) => {
      let montaObjeto;
      montaObjeto.listaIdDescricao = data;
      montaObjeto.pesquisa = new LancamentoPesquisa();
      this.listaNivel.push(montaObjeto);
    }
    );
  }

  declaraNiveis() {
    if (this.pesquisaNivel4.TipoDR) {
      this.nivel4 = true;
      this.pesquisa.TipoDR = this.pesquisaNivel4.TipoDR;
    } else if (this.pesquisaNivel3.TipoDR) {
      this.nivel3 = true;
      this.pesquisa.TipoDR = this.pesquisaNivel3.TipoDR;
    } else if (this.pesquisaNivel2.TipoDR) {
      this.nivel2 = true;
      this.pesquisa.TipoDR = this.pesquisaNivel2.TipoDR;
    } else if (this.pesquisaNivel1.TipoDR) {
      this.nivel1 = true;
      this.pesquisa.TipoDR = this.pesquisaNivel1.TipoDR;
    } else if (this.pesquisaPai.TipoDR) {
      this.nivelPai = true;
      this.pesquisa.TipoDR = this.pesquisaPai.TipoDR;
    }
  }

  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("extratoBancario").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório extrato bancário", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    
    parseDateAdicionaMap('Data Inicial', this.pesquisa.DataInicial);
    parseDateAdicionaMap('Data Final', this.pesquisa.DataFinal);
    
    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.pesquisa.UnidadeId);
    obtemDescricaoAdicionaMap('Tipo de Ação', this.lstTipoAcao, this.pesquisa.TipoDeAcaoId);
    obtemDescricaoAdicionaMap('Conta', this.lstConta, this.pesquisa.ContaId);

    if(this.tipoPesquisa === 'simples')
    {
      obtemDescricaoAdicionaMap('Tipo DR', this.lstTipoDR, Number(this.pesquisa.TipoDR));
    }
    else
    {
      if(this.nivel4)
      {
        obtemDescricaoAdicionaMap('Tipo DR', this.lstNivel4, Number(this.pesquisaNivel4.TipoDR));
      }
      else if(this.nivel3)
      {
        obtemDescricaoAdicionaMap('Tipo DR', this.lstNivel3, Number(this.pesquisaNivel3.TipoDR));
      }
      else if(this.nivel2)
      {
        obtemDescricaoAdicionaMap('Tipo DR', this.lstNivel2, Number(this.pesquisaNivel2.TipoDR));
      }
      else if(this.nivel1)
      {
        obtemDescricaoAdicionaMap('Tipo DR', this.lstNivel1, Number(this.pesquisaNivel1.TipoDR));
      }
      else
      {
        obtemDescricaoAdicionaMap('Tipo DR', this.lstGrupoPai, Number(this.pesquisaPai.TipoDR));
      }
    }

    adicionaMapValido("Saldo Total", "R$ " + this.saldoTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }));

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })

    return stringHtml;
  }

  public gerarCSV() {
    let unidadeFiltrada = this.lstUnidades.find(item => item.Id === this.pesquisa.UnidadeId).Descricao;
    let contaFiltrada = this.lstConta.find(item => item.Id === this.pesquisa.ContaId).Descricao;
    let dataInicialFormatada = this.pesquisa.DataInicial;
    let dataFinalFormatada = this.pesquisa.DataFinal;

    let nomeArquivo = `${unidadeFiltrada}_${contaFiltrada}_${dataInicialFormatada}_${dataFinalFormatada}.csv`;
    this.relatorioService.montarArquivoCSV(this.pesquisa, this.tipoPesquisa)
      .toPromise()
      .then(
        data => this.utilitarioService.saveAs(data, nomeArquivo)
      );
  }

}
